<script>
    import Navbar from "../widget/Navbar.svelte";
    import Footer from "../widget/Footer.svelte";
</script>
<Navbar/>
<div class="container text-center p-3">
  <h1>Welcome to</h1>
  <img class="img-fluid rounded-circle" src="https://1.bp.blogspot.com/-kRB19vZdSOk/YDc6FGUOCgI/AAAAAAAANGc/CpwzKyuvxSodL61CSOobQO_zBzYPu5iIgCLcBGAsYHQ/s300/unicenta_device_dark_300.png" alt="unicenta pos svelte web apps"/>
  <br><img class="img-fluid" src="https://1.bp.blogspot.com/-kEdzN7AdSTQ/YDZLAt-auvI/AAAAAAAANE8/tLb0TUK785YwtOSNmIcWG0LS0IDOllqaQCLcBGAsYHQ/s168/uni.png" alt="unicenta pos svelte web apps"/>
  <p>
    This is a free and open source code for dashboard admin unicenta backoffice , built using svelte kit make your web app very fast. how to install ?? read documentation.
  </p>
  <a href="https://www.hockeycomputindo.com/2021/11/how-to-install-unicenta-web-app-svelte.html" class="border border-secondary text-secondary p-1">Documentation →</a>
  </div>
  
<Footer/>